import styles from "./styles.module.css";

const Item = ({
  data,
  onClick = () => {},
  className = "",
  textClassName = "",
}) => {
  return (
    <button onClick={onClick} className={`${styles.btn} ${className}`}>
      <p className={`${styles.text} ${textClassName}`}>{data.title}</p>
    </button>
  );
};

export default Item;
